import { render } from "./DownloadCF2Button.vue?vue&type=template&id=71a7c0f8"
import script from "./DownloadCF2Button.vue?vue&type=script&lang=js"
export * from "./DownloadCF2Button.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__